import type { RawSource } from '@pharmafiche/schema';

interface SourceChipProps {
  source: RawSource;
  onRemove: (id: string) => void;
}

const KIND_ICON: Record<RawSource['kind'], string> = {
  pdf: '📄',
  image: '🖼️',
  text: '📝',
};

function formatChars(n: number): string {
  if (n < 1000) return `${n} car.`;
  if (n < 10000) return `${(n / 1000).toFixed(1)} k car.`;
  return `${Math.round(n / 1000)} k car.`;
}

export function SourceChip({ source, onRemove }: SourceChipProps) {
  return (
    <span
      className="inline-flex items-center gap-2 max-w-full bg-white border-2 border-ink rounded-full px-3 py-1 font-hand text-[14px] text-ink shadow-ink-sm"
      data-source-id={source.id}
      data-testid="source-chip"
    >
      <span aria-hidden>{KIND_ICON[source.kind]}</span>
      <span
        className="truncate max-w-[180px]"
        title={source.label}
        style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
      >
        {source.label}
      </span>
      {source.page_range ? (
        <span className="text-ink-soft text-[12px]">
          p. {source.page_range[0]}–{source.page_range[1]}
        </span>
      ) : null}
      <span className="text-ink-soft text-[12px]">{formatChars(source.text.length)}</span>
      <button
        type="button"
        onClick={() => onRemove(source.id)}
        aria-label={`Supprimer la source ${source.label}`}
        className="inline-grid place-items-center w-5 h-5 rounded-full bg-paper hover:bg-warn-bg text-ink hover:text-warn-text border border-ink/30 text-[12px] leading-none"
      >
        ✕
      </button>
    </span>
  );
}
